export var MAX_PRODUCTS_IN_VIEW = 4;
export var MIN_SEARCH_TERM_LENGTH = 0;
export var MAX_TRENDING_SEARCH_TERMS = 10;
export var MAX_RECENT_SEARCH_TERMS = 10;
export var RECENT_SEARCH_TERMS_KEY = "recent-search-terms";
export var MAX_ENHANCED_SEARCH_PRODUCTS_IN_VIEW = 4;
export var getSearchEndpoint = function getSearchEndpoint(searchTerm) {
  return "/search-lite.json?query=".concat(searchTerm, "&search_src=topbar&ac=0&limit=").concat(MAX_PRODUCTS_IN_VIEW);
};